export default "__VITE_ASSET__BoT3Z1jh__"